import React from "react";
import { useNavigate } from "react-router-dom";

function Breadcrumb(props) {
  const navigate = useNavigate();
  const { routes, finalText, finalText2 } = props;

  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {routes.map((route, key) => {
          return route.path !== "" ? (
            <li className="breadcrumb-item" key={key}>
              <a
                onClick={(e) => {
                  changeRoute(e, route.path);
                }}
              >
                {route.name}
              </a>
            </li>
          ) : (
            <li className="breadcrumb-item" aria-current="page" key={key}>
              {route.name}
            </li>
          );
        })}
      </ol>
      {finalText && (
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <div>
              <div style={{marginBottom : '4px'}} dangerouslySetInnerHTML={{ __html: finalText2 }} className="notice" ></div>
              <div dangerouslySetInnerHTML={{ __html: finalText }} className="notice"></div>
            </div>
          </li>
        </ol>
      )}
    </nav>
  );
}

export default Breadcrumb;
